import { cmsInstance } from '../config/backend';
import {
    OrderConfirmation,
    OrderFormResponse,
    OrderStatusResponse,
    PayPayload,
    PaymentResult,
    SubmitOrderPayload,
} from '../common/types/CartType';

// Ordering goes through our own backend, never straight to the dashboard:
// the ingest key lives there. Prices and dish names are not sent — the
// backend reads them from the CMS so the browser cannot set them.

export async function fetchOrderForm(menuId: number): Promise<OrderFormResponse> {
    const { data } = await cmsInstance.get<OrderFormResponse>(`/order/form/${menuId}`);
    return data;
}

export async function submitOrder(payload: SubmitOrderPayload): Promise<OrderConfirmation> {
    const { data } = await cmsInstance.post<OrderConfirmation>('/order', payload);
    return data;
}

// Only the payment token and the tip travel from here. Every amount is
// read server-side from the order that was already created, so a tampered
// request cannot change what is charged.
export async function payOrder(orderId: string, payload: PayPayload): Promise<PaymentResult> {
    const { data } = await cmsInstance.post<PaymentResult>(`/order/${orderId}/pay`, payload);
    return data;
}

// Polled while an asynchronous payment settles — a card resolves inside
// the pay request, but a wallet may finish only once Square's webhook
// reaches the dashboard.
export async function fetchOrderStatus(orderId: string): Promise<OrderStatusResponse> {
    const { data } = await cmsInstance.get<OrderStatusResponse>(`/order/${orderId}/status`);
    return data;
}
